import React, { Component } from 'react';
import moment from 'moment';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Spinner } from 'react-activity';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import Headers from '../Header';
import NavigationBar from '../Navigation';
import 'react-datepicker/dist/react-datepicker.css';
import {
    getSubCategoryList,
    getEducatorList,
    getEducatorAvailability,
    postOndemandAppointment,
    getEducatorAvailablityDays,
} from '../../../action/student/AppointmentAction';
import { RESPONSE_CONSTANT } from '../../../../utils/ResponseConstant';
import TimeSlots from '../../common/TimeSlots';
import { PATH } from '../../../../utils/Constants';
import { showNotification } from '../../../action/NotificationAction';
import { customStyles } from '../../../../utils/Utility';
import store from '../../../../sessionStorage';
import { getStudentEducatorSubject } from '../../../action/student/DashboardAction';
import AppConfig from '../../../../utils/common/DomainConfiguration';
import LanguageContext, { LanguageProvider } from '../../../../utils/common/LanguageContext';

// Register Spanish locale for DatePicker
registerLocale('es', es);

const withLanguage = (Component) => {
    return (props) => (
        <LanguageContext.Consumer>
            {({ t, language }) => <Component {...props} t={t} language={language} />}
        </LanguageContext.Consumer>
    );
};

class CreateSession extends Component {
    static propTypes = {
        getStudentEducatorSubject: PropTypes.func,
        getSubCategoryList: PropTypes.func,
    };
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            mobileNav: false,
            openTimeShotModal: false,
            subjectId: '',
            date: '',
            summary: '',
            uploadedImage: [],
            isImageUploaded: false,
            educatorId: '',
            isOneToOne: true,
            subcategoryId: '',
            subjectList: [],
            subCategoryList: [],
            timeSlots: [],
            educatorList: [],
            timeApp: [],
            myValues: [],
            startDate: new Date(),
            tutorAvailableDays: [],
            tutorAvailableTimes: [],
            appointmentType: 2,
            isSubjectLoading: false,
            isSubcategoryLoading: false,
            isEducatorLoading: false,
            disableSubject: false,
            disableSubcategory: false,
            disableEducator: false,
            isSubjectReferral: false,
        };
    }

    // componentDidMount
    componentDidMount() {
        const searchParams = new URLSearchParams(window.location.search);
        const studentId = searchParams.get('studentId');
        const name = searchParams.get('name');
        const subjectName = searchParams.get('subjectName');
        const subcategoryName = searchParams.get('subcategoryName');
        const isSubjectReferral = searchParams.get('isSubjectReferral');
        if (studentId) {
            this.setState({
                studentId: { label: name, value: studentId },
                isFromStudent: true,
            });
            this.setState({
                isSubjectReferral: isSubjectReferral,
            });
        }
        this.getEducatorList(subjectName, subcategoryName, name);
    }

    //componentDidUpdate
    componentDidUpdate(prevProps, prevState) {
        if (this.state.educatorId !== prevState.educatorId) {
            if (this.state.isOneToOne) {
                this.getEducatorAvailablityDays(this.state.educatorId.value);
            }
        }
        if (this.state.appointmentType !== prevState.appointmentType) {
            this.getEducatorList();
        }
    }

    getStudentEducatorSubject(educatorId, subjectName, subcategoryName) {
        this.setState({ isSubjectLoading: true });
        this.props.getStudentEducatorSubject(
            educatorId,
            { pageNumber: 1, itemsPerPage: 99999 },
            (response) => {
                this.setState({ isSubjectLoading: false });
                if (response && response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    const subjects = response.response.data;
                    this.setState({ subjectList: subjects });
                    if (subjectName) {
                        const subject = subjects.find((sub) => sub.label === subjectName);
                        if (subject) {
                            this.setState({ subjectId: subject, disableSubject: true }, () => {
                                this.getSubCategoryList(subject.value, subcategoryName);
                            });
                        } else {
                            this.setState({ disableSubject: false });
                        }
                    }
                }
            }
        );
    }

    // getSubCategoryList
    getSubCategoryList = (subjectId, subcategoryName) => {
        this.setState({ isSubcategoryLoading: true });
        this.props.getSubCategoryList(
            subjectId,
            { pageNumber: 1, itemsPerPage: 99999 },
            (response) => {
                this.setState({ isSubcategoryLoading: false });
                if (response && response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    const subcategories = response.response.data;
                    this.setState({ subCategoryList: subcategories });
                    if (subcategoryName) {
                        const subcategory = subcategories.find(
                            (sub) => sub.label === subcategoryName
                        );
                        if (subcategory) {
                            this.setState({
                                subcategoryId: subcategory,
                                disableSubcategory: true,
                            });
                        } else {
                            this.setState({ disableSubcategory: false });
                        }
                    }
                } else {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
                    this.setState({ subCategoryList: [] });
                }
            }
        );
    };

    // getEducatorList
    getEducatorList = (subjectName, subcategoryName, educatorName) => {
        this.setState({ isEducatorLoading: true });
        this.props.getEducatorList(
            this.state.appointmentType,
            { pageNumber: 1, itemsPerPage: 99999 },
            (response) => {
                this.setState({ isEducatorLoading: false });
                if (response && response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    const educators = response.response.data;
                    this.setState({ educatorList: educators });
                    if (educatorName) {
                        const educator = educators.find((edu) => edu.label === educatorName);
                        if (educator) {
                            this.setState({ educatorId: educator, disableEducator: true }, () => {
                                this.getStudentEducatorSubject(
                                    educator.value,
                                    subjectName,
                                    subcategoryName
                                );
                            });
                        } else {
                            this.setState({ disableEducator: false });
                        }
                    }
                } else {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
                    this.setState({ educatorList: [] });
                }
            }
        );
    };

    // Get Educator Availability Days
    getEducatorAvailablityDays(educatorId) {
        this.props.getEducatorAvailablityDays(educatorId, (response) => {
            if (response) {
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    this.setState({
                        tutorAvailableDays: response.response.availableDays,
                        tutorAvailableTimes: response.response.availableTimes,
                    });
                } else {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
                    this.setState({ tutorAvailableDays: [], tutorAvailableTimes: [] });
                }
            }
        });
    }

    // handleChangeTime
    handleChangeTime = (timingId) => {
        const { timeApp } = this.state;
        if (timeApp && timeApp.length) {
            const getPrevList = timeApp.findIndex((i) => {
                return i.slotId === timingId;
            });
            if (getPrevList !== -1) {
                timeApp.splice(getPrevList, 1);
                const newSlotIds = timeApp.map((option) => option.slotId);
                this.setState({ timeApp, slotIds: newSlotIds });
                store.set('slotIds', newSlotIds);
                store.set('inSTimeApp', timeApp);
                return;
            }
        }
        timeApp.push({ slotId: timingId });
        const newSlotIds = timeApp.map((option) => option.slotId);
        this.setState({
            timeApp,
            slotIds: newSlotIds,
        });
        store.set('slotIds', newSlotIds);
        store.set('inSTimeApp', timeApp);
    };

    // onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    // handleFileUpload
    handleFileUpload = (event) => {
        const files = event.target.files;
        const MAX_TOTAL_SIZE = 52428800;
        const MAX_SINGLE_FILE_SIZE = 10485760;
        let { totalUploadedSize = 0, uploadedImage = [] } = this.state;
        let newUploadSize = 0;
        const validFiles = [];
        const readerPromises = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (
                (file.type === 'image/png' ||
                    file.type === 'image/jpeg' ||
                    file.type === 'image/jpg' ||
                    file.type === 'application/pdf') &&
                file.size <= MAX_SINGLE_FILE_SIZE
            ) {
                newUploadSize += file.size;
                if (totalUploadedSize + newUploadSize > MAX_TOTAL_SIZE) {
                    this.setState({ isImageUploaded: false });
                    this.props.showNotification(
                        RESPONSE_CONSTANT.MEDIA_TOTAL_SIZE_EXCEEDED,
                        RESPONSE_CONSTANT.WARNING
                    );
                    return;
                }
                validFiles.push({ file, size: file.size }); // Store the file and its size
            } else if (file.size > MAX_SINGLE_FILE_SIZE) {
                this.setState({ isImageUploaded: false });
                this.props.showNotification(
                    RESPONSE_CONSTANT.MEDIA_FILE_SIZE,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            } else {
                this.setState({ isImageUploaded: false });
                this.props.showNotification(
                    RESPONSE_CONSTANT.UPLOAD_ONLY_IMAGE,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
        }
        validFiles.forEach(({ file }) => {
            const reader = new FileReader();
            readerPromises.push(
                new Promise((resolve) => {
                    reader.onloadend = () => resolve({ result: reader.result, size: file.size });
                    reader.readAsDataURL(file);
                })
            );
        });
        Promise.all(readerPromises).then((base64Results) => {
            const newTotalSize = totalUploadedSize + newUploadSize;
            this.setState({
                uploadedImage: [...uploadedImage, ...base64Results.map((res) => res.result)],
                totalUploadedSize: newTotalSize,
            });
        });
    };

    // removeObject
    removeObject = (id, type) => {
        if (type === 'slot') {
            const newTimeApp = [...this.state.timeApp];
            newTimeApp.splice(id, 1);
            const newSlotIds = newTimeApp.map((slot) => slot.slotId);
            this.setState({ timeApp: newTimeApp, slotIds: newSlotIds }, () => {
                if (this.state.timeApp.length === 0) {
                    this.setState({ openTimeShotModal: true });
                }
            });
        } else {
            const newArray = [...this.state.uploadedImage];
            const removedFileSize = newArray[id].size;
            newArray.splice(id, 1);
            const newTotalSize = this.state.totalUploadedSize - removedFileSize;
            this.setState({
                uploadedImage: newArray,
                totalUploadedSize: newTotalSize,
            });
        }
    };

    // handleSubmitOndemand
    handleSubmitOndemand = () => {
        const userSession = JSON.parse(sessionStorage.getItem('userSession'));
        const sessionID = userSession.student.id;
        if (!this.state.date || !this.state.timeApp.length) {
            this.props.showNotification(
                RESPONSE_CONSTANT.SELECT_DATE_TIME,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        if (!this.state.educatorId) {
            this.props.showNotification(
                RESPONSE_CONSTANT.EDUCATOR_MANDATORY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        this.setState({ isLoading: true });
        const { timeSlots, timeApp } = this.state;
        const selectedSlots = timeApp
            .map((item) => {
                return timeSlots.find((slot) => slot.id === item.slotId);
            })
            .filter((slot) => slot !== undefined);
        const hasCustomAvailability = selectedSlots.some((slot) => slot.customAvailability);
        let sortedSlots = [];
        if (hasCustomAvailability) {
            sortedSlots = selectedSlots.sort((a, b) => {
                return moment(a.startTime).diff(moment(b.startTime));
            });
            let nonSequentialSlots = [];
            for (let i = 0; i < sortedSlots.length - 1; i++) {
                const currentEndTime = moment(sortedSlots[i].endTime);
                const nextStartTime = moment(sortedSlots[i + 1].startTime);
                if (!nextStartTime.isSame(currentEndTime)) {
                    nonSequentialSlots.push({
                        currentStartTime: sortedSlots[i].startTime,
                        nextStartTime: sortedSlots[i + 1].startTime,
                    });
                }
            }
            if (nonSequentialSlots.length > 0) {
                const chosenDate = moment(this.state.date).format('DD-MM-YYYY');
                const unsequencedSlots = nonSequentialSlots
                    .map((slot) => {
                        return `${moment(slot.currentStartTime).format(
                            'HH:mm'
                        )} to ${moment(slot.nextStartTime).format('HH:mm')}`;
                    })
                    .join(', ');
                this.props.showNotification(
                    `Slots chosen date: ${chosenDate}, slots are not in sequence. Please choose the sequential slots. Unsequenced slots: ${unsequencedSlots}`,
                    'error'
                );
                this.setState({ isLoading: false });
                return;
            }
        }
        if (this.state.isOneToOne) {
            let startTime = null;
            let endTime = null;
            if (selectedSlots.length > 0) {
                startTime = selectedSlots[0].startTime;
                endTime = selectedSlots[selectedSlots.length - 1].endTime;
            }
            let data = {
                tutorId: this.state.educatorId.value,
                sessionDate: moment(this.state.date).format('YYYY-MM-DD'),
                expertiseCategoryId: this.state.subjectId.value,
                expertiseId: this.state.subcategoryId?.value || null,
                gradeId: 13,
                studentId: sessionID,
                visitType: 2,
                topic: this.state.summary,
                referenceFiles: this.state.uploadedImage,
                sessionStartTime: startTime,
                sessionEndTime: endTime,
                isSubjectReferral: this.state.isSubjectReferral,
            };
            if (hasCustomAvailability) {
                data.slotIds = [];
            } else {
                const slotIds = this.state.slotIds || store.get('slotIds');
                data.slotIds = slotIds;
            }
            this.props.onDemandBook(data, (res) => {
                this.setState({ isLoading: false });
                if (res.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    this.props.showNotification(res.message, 'success');
                    this.props.history.push(
                        `${PATH.IM_PATIENT.APPOINTMENT}/${this.props.match.params.userId}`
                    );
                } else {
                    this.props.showNotification(res.message, 'error');
                }
            });
        }
    };

    // resetStateValue
    resetStateValue = () => {
        this.setState({
            subjectId: '',
            subcategoryId: '',
            date: '',
            timeApp: [],
            educatorId: '',
            summary: '',
            uploadedImage: [],
            disableSubject: '',
            disableSubcategory: '',
            disableEducator: '',
        });
    };

    // handleSubmitCreateAppointment
    handleSubmitCreateAppointment = () => {
        const userSession = JSON.parse(sessionStorage.getItem('userSession'));
        const sessionID = userSession.student.id;
        if (!this.state.educatorId) {
            this.props.showNotification(
                RESPONSE_CONSTANT.EDUCATOR_MANDATORY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        this.setState({ isLoading: true });
        let data = {
            tutorId: this.state.educatorId.value,
            sessionDate: moment().format('YYYY-MM-DD'),
            expertiseCategoryId: this.state.subjectId.value,
            expertiseId: this.state.subcategoryId?.value || null,
            gradeId: 13,
            studentId: sessionID,
            visitType: 1,
            topic: this.state.summary,
            slotId: [],
            referenceFiles: this.state.uploadedImage,
        };
        this.props.onDemandBook(data, (res) => {
            this.setState({ isLoading: false });
            if (res.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(res.message, 'success');
                this.props.history.push(
                    `${PATH.IM_PATIENT.APPOINTMENT}/${this.props.match.params.userId}`
                );
            } else {
                this.props.showNotification(res.message, 'error');
            }
        });
    };

    // handleOneToOneCheckboxChange
    handleOneToOneCheckboxChange = () => {
        this.setState({ isOneToOne: !this.state.isOneToOne });
        this.resetStateValue();
    };

    // getAvailableSlots
    getAvailableSlots = (date, educator) => {
        store.set('slotIds', []);
        this.props.getEducatorAvailability(
            educator,
            moment(date).format('YYYY-MM-DD'),
            (response) => {
                if (response) {
                    if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.setState({ timeSlots: response.response.slots });
                    } else {
                        this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
                        this.setState({ timeSlots: [] });
                    }
                }
            }
        );
    };

    // filterDates
    filterDates = (date) => {
        const dayOfWeek = date.getDay();
        const { tutorAvailableDays, tutorAvailableTimes } = this.state;
        const availableDays = tutorAvailableDays.map((day) => (day === 1 ? 0 : day - 1));
        const isDayAvailable = availableDays.includes(dayOfWeek);
        if (tutorAvailableTimes && tutorAvailableTimes.length > 0) {
            const selectedDate = date.setHours(0, 0, 0, 0);
            const isDateAvailable = tutorAvailableTimes.some((time) => {
                const startTime = new Date(time.startTime).setHours(0, 0, 0, 0);
                const endTime = new Date(time.endTime).setHours(0, 0, 0, 0);
                return selectedDate >= startTime && selectedDate <= endTime;
            });
            return isDayAvailable || isDateAvailable;
        } else {
            return isDayAvailable;
        }
    };

    //customOptionLabel
    customOptionLabel = ({ label }) => (
        <div className="overflow-hidden truncate" title={label}>
            {label}
        </div>
    );

    render() {
        return (
            <div className="fixed top-0 left-0 flex w-full h-full">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                        this.state.mobileNav ? 'block' : 'hidden'
                    }`}
                ></div>
                <NavigationBar
                    nav={true}
                    {...this.props}
                    active={PATH.IM_PATIENT.APPOINTMENT}
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-col flex-grow">
                    <Headers
                        {...this.props}
                        title={this.props.t('createSession')}
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="flex flex-col w-full h-full py-8 overflow-auto bg-UIBackground">
                        <div className="items-center justify-between px-4 sm:flex sm:px-8">
                            <h6 className="m-0 text-lg font-semibold text-white">
                                {this.props.t('createSession')}
                            </h6>
                        </div>
                        <div className="flex flex-col gap-4 px-4 pt-6 sm:px-8">
                            <div className="flex flex-col w-full p-6 rounded-lg bg-card">
                                <div className="flex justify-end  text-[#B9B9B9] text-base font-normal">
                                    <p className="before:content-['*'] before:ml-0.5 before:text-[#10DACE] mb-3">
                                        {this.props.t('indicatesRequiredFields')}
                                    </p>
                                </div>
                                <div className="flex-col-reverse items-center justify-between sm:flex sm:flex-row">
                                    <div className="flex mb-4 radiobox gap-x-8 sm:mb-0">
                                        <div className="flex items-center mb-4 gap-x-3 sm:mb-0">
                                            <input
                                                onClick={() =>
                                                    this.setState({ appointmentType: 2 })
                                                }
                                                id="one-to-one"
                                                name="one-to-one"
                                                type="radio"
                                                className="cursor-pointer"
                                                checked={this.state.isOneToOne}
                                                onChange={this.handleOneToOneCheckboxChange}
                                                style={{ padding: '3px' }}
                                            />
                                            <label
                                                htmlFor="select-one-one"
                                                className={`block text-base ${
                                                    this.state.isOneToOne
                                                        ? 'font-normal'
                                                        : 'font-normal'
                                                }  text-white`}
                                            >
                                                {this.props.t('appointment')}
                                            </label>
                                        </div>
                                        {/* <div className="flex items-center gap-x-3">
                      <input
                        id="classroom"
                        name="classroom"
                        type="radio"
                        className="cursor-pointer"
                        checked={!this.state.isOneToOne}
                        onChange={this.handleOneToOneCheckboxChange}
                        style={{ padding: "3px" }}
                        onClick={() => this.setState({ appointmentType: 1 })}
                      />
                      <label
                        htmlFor="select-classroom"
                        className={`block text-base ${
                          !this.state.isOneToOne ? "font-normal" : "font-normal"
                        } leading-6 text-white`}
                      >
                        On Demand
                      </label>
                    </div> */}
                                    </div>
                                </div>
                                <div className="grid grid-cols-12">
                                    <div className="col-span-12 mt-3 sm:col-span-9">
                                        <div className="grid grid-cols-1">
                                            <div>
                                                <label
                                                    htmlFor="countries"
                                                    className="block mb-2 text-base font-normal text-white mt-6 after:content-['*'] after:ml-0.5 after:text-[#10DACE]"
                                                >
                                                    {this.props.t('selectOwner')}
                                                </label>
                                                <Select
                                                    isLoading={this.state.isEducatorLoading}
                                                    id="countries"
                                                    name="educator"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            educatorId: event,
                                                            subjectId: '',
                                                            subcategoryId: '',
                                                            date: '',
                                                            timeApp: [],
                                                            summary: '',
                                                            uploadedImage: [],
                                                        });
                                                        this.getEducatorAvailablityDays(
                                                            event.value
                                                        );
                                                        this.getStudentEducatorSubject(event.value);
                                                    }}
                                                    value={this.state.educatorId}
                                                    ref={(r) => (this.selectRef = r)}
                                                    className="block rounded whitespace-nowrap text-secondary text-md border-black-10"
                                                    options={
                                                        this.state.educatorList &&
                                                        this.state.educatorList.length
                                                            ? this.state.educatorList
                                                            : []
                                                    }
                                                    styles={customStyles}
                                                    placeholder={this.props.t('searchOwnerName')}
                                                    onKeyDown={(event) => {
                                                        const key = event.key;
                                                        const allowedCharacters =
                                                            /^[a-zA-Z0-9\s]+$/;
                                                        if (
                                                            !allowedCharacters.test(key) ||
                                                            (event.keyCode === 32 &&
                                                                !this.selectRef.state.inputValue)
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    formatOptionLabel={this.customOptionLabel}
                                                    isDisabled={!!this.state.disableEducator}
                                                />
                                            </div>
                                        </div>
                                        <div className="grid gap-4 sm:grid-cols-2">
                                            <div>
                                                <label
                                                    htmlFor="select-subject"
                                                    className="block mt-6 mb-2 text-base font-normal text-white"
                                                >
                                                    Select {AppConfig.labels.channelName}
                                                </label>
                                                <Select
                                                    isLoading={this.state.isSubjectLoading}
                                                    id="subject"
                                                    name="subject"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            subjectId: event,
                                                            subcategoryId: '',
                                                            date: '',
                                                            timeApp: [],
                                                            summary: '',
                                                            uploadedImage: [],
                                                        });
                                                        this.getSubCategoryList(event.value);
                                                    }}
                                                    value={this.state.subjectId}
                                                    ref={(r) => (this.subjectRef = r)}
                                                    className="block rounded whitespace-nowrap text-secondary text-md border-black-10"
                                                    options={
                                                        this.state.subjectList.length > 0
                                                            ? this.state.subjectList.map(
                                                                  (subject) => ({
                                                                      value: subject.id,
                                                                      label: subject.name,
                                                                  })
                                                              )
                                                            : []
                                                    }
                                                    styles={customStyles}
                                                    placeholder={`Select any ${AppConfig.labels.channelName}`}
                                                    onKeyDown={(event) => {
                                                        const key = event.key;
                                                        const allowedCharacters =
                                                            /^[a-zA-Z0-9\s]+$/;
                                                        if (
                                                            !allowedCharacters.test(key) ||
                                                            (event.keyCode === 32 &&
                                                                !this.subjectRef.state.inputValue)
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    isDisabled={!!this.state.disableSubject}
                                                />
                                            </div>
                                            <div>
                                                <label
                                                    htmlFor="select-subcategory"
                                                    className="block mt-6 mb-2 text-base font-normal text-white rounded"
                                                >
                                                    {this.props.t('selectElement')}
                                                </label>
                                                <Select
                                                    isLoading={this.state.isSubcategoryLoading}
                                                    id="subcategory"
                                                    name="subcategory"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            subcategoryId: event,
                                                            date: '',
                                                            timeApp: [],
                                                            summary: '',
                                                            uploadedImage: [],
                                                        });
                                                    }}
                                                    value={this.state.subcategoryId}
                                                    ref={(r) => (this.subcategoryRef = r)}
                                                    className="block rounded whitespace-nowrap text-secondary text-md border-black-10"
                                                    options={
                                                        this.state.subCategoryList &&
                                                        this.state.subCategoryList.length
                                                            ? this.state.subCategoryList
                                                            : []
                                                    }
                                                    styles={customStyles}
                                                    placeholder={this.props.t('selectElement')}
                                                    onKeyDown={(event) => {
                                                        const key = event.key;
                                                        const allowedCharacters =
                                                            /^[a-zA-Z0-9\s]+$/;
                                                        if (
                                                            !allowedCharacters.test(key) ||
                                                            (event.keyCode === 32 &&
                                                                !this.subcategoryRef.state
                                                                    .inputValue)
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    isDisabled={!!this.state.disableSubcategory}
                                                />
                                            </div>
                                        </div>
                                        {this.state.isOneToOne && (
                                            <div className="grid gap-0 sm:grid-cols-2 sm:gap-4">
                                                <div className="inputgroup">
                                                    <label
                                                        htmlFor="select-date"
                                                        className="block mb-2 text-base font-normal rounded text-white mt-6 after:content-['*'] after:ml-0.5 after:text-[#10DACE]"
                                                    >
                                                        {this.props.t('date')}
                                                    </label>
                                                    <div className="relative flex flex-wrap items-stretch w-full mb-0">
                                                        <div className="flex w-full mb-2 rounded bg-dateselect">
                                                            <div className="grow">
                                                                <DatePicker
                                                                    name="date"
                                                                    className="w-full text-white placeholder:text-[#B9B9B9] text-base px-2 datepicker-opacity example-custom-input"
                                                                    wrapperClassName="w-full"
                                                                    placeholderText={this.props.t(
                                                                        'selectDate'
                                                                    )}
                                                                    selected={
                                                                        (this.state.date &&
                                                                            new Date(
                                                                                this.state.date
                                                                            )) ||
                                                                        null
                                                                    }
                                                                    value={this.state.date}
                                                                    onChangeRaw={(e) => {
                                                                        this.setState({
                                                                            date: e.target.value,
                                                                        });
                                                                    }}
                                                                    onChange={(event) => {
                                                                        this.getAvailableSlots(
                                                                            event,
                                                                            this.state.educatorId
                                                                                .value
                                                                        );
                                                                        this.setState({
                                                                            educatorId:
                                                                                this.state
                                                                                    .educatorId,
                                                                            date: event,
                                                                            startDate: event,
                                                                            timeApp: [],
                                                                        });
                                                                    }}
                                                                    dropdownMode="select"
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    scrollableYearDropdown
                                                                    maxDate={
                                                                        new Date(
                                                                            moment(
                                                                                new Date(),
                                                                                'DD-MM-YYYY'
                                                                            ).add(6, 'months')
                                                                        )
                                                                    }
                                                                    minDate={new Date()}
                                                                    autoComplete="off"
                                                                    filterDate={this.filterDates}
                                                                    locale={
                                                                        this.props.language === 'es'
                                                                            ? 'es'
                                                                            : 'en'
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="inputgroup">
                                                    <label
                                                        htmlFor="select-time"
                                                        data-modal-target="defaultModal"
                                                        data-modal-toggle="defaultModal"
                                                        className="block mb-2 text-base font-normal rounded text-white mt-6 after:content-['*'] after:ml-0.5 after:text-[#10DACE]"
                                                    >
                                                        {this.props.t('time')}
                                                    </label>
                                                    <div
                                                        className="flex items-center justify-between px-2 rounded cursor-pointer bg-dateselect time-height text-secondary"
                                                        onClick={() => {
                                                            if (
                                                                this.state.timeApp &&
                                                                !this.state.timeApp.length
                                                            ) {
                                                                this.setState({
                                                                    openTimeShotModal:
                                                                        !this.state
                                                                            .openTimeShotModal,
                                                                });
                                                            }
                                                        }}
                                                    >
                                                        <div className="flex flex-wrap justify-start gap-2 align-baseline">
                                                            {this.state.timeApp &&
                                                            this.state.timeApp.length ? (
                                                                <>
                                                                    {this.state.timeApp.map(
                                                                        (res, index) => {
                                                                            const isSelected =
                                                                                this.state.timeSlots.find(
                                                                                    (i) => {
                                                                                        return (
                                                                                            i.id ===
                                                                                            res.slotId
                                                                                        );
                                                                                    }
                                                                                );
                                                                            if (isSelected) {
                                                                                return (
                                                                                    <>
                                                                                        <button
                                                                                            className="px-2 text-xs font-normal text-white rounded-lg bg-UIprimary whitespace-nowrap focus:bg-UIprimary focus:text-white hover:bg-UIprimary hover:text-white padding-slot"
                                                                                            key="index"
                                                                                        >
                                                                                            {moment(
                                                                                                isSelected.startTime
                                                                                            ).format(
                                                                                                'hh:mm A'
                                                                                            )}
                                                                                            <i
                                                                                                className="align-middle fal fa-times ms-2"
                                                                                                onClick={() => {
                                                                                                    this.removeObject(
                                                                                                        index,
                                                                                                        'slot'
                                                                                                    );
                                                                                                }}
                                                                                            ></i>
                                                                                        </button>
                                                                                    </>
                                                                                );
                                                                            } else {
                                                                                return null;
                                                                            }
                                                                        }
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <p className="mb-0 text-[#B9B9B9]">
                                                                    {this.props.t('selectTime')}
                                                                </p>
                                                            )}
                                                        </div>
                                                        <i
                                                            className="fa-regular fa-clock text-[#10DACE]"
                                                            onClick={() => {
                                                                if (
                                                                    this.state.timeApp &&
                                                                    this.state.timeApp.length
                                                                ) {
                                                                    this.setState({
                                                                        openTimeShotModal:
                                                                            !this.state
                                                                                .openTimeShotModal,
                                                                    });
                                                                }
                                                            }}
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <div className="grid grid-cols-1 mt-6">
                                            <div>
                                                <label
                                                    htmlFor="select-about"
                                                    className="block mb-2 text-base font-normal text-white "
                                                >
                                                    {this.props.t('additionalSummary')}
                                                </label>
                                                <textarea
                                                    id="about"
                                                    name="about"
                                                    rows="3"
                                                    maxLength="300"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            summary: event.target.value,
                                                        });
                                                    }}
                                                    value={this.state.summary}
                                                    placeholder={this.props.t('summaryPlaceholder')}
                                                    className="block w-full p-2 text-white rounded bg-dateselect placeholder:text-[#B9B9B9] sm:text-base focus:outline-none focus:ring-1 focus:ring-blue-500"
                                                />
                                            </div>
                                        </div>
                                        <div className="grid mt-6 sm:grid-cols-2">
                                            <div className="">
                                                <label className="block text-base font-normal leading-6 text-white">
                                                    {this.props.t('uploadFiles')}
                                                </label>
                                                <div className="flex justify-center mt-2 rounded bg-dateselect">
                                                    <div className="mt-6 text-center">
                                                        <input
                                                            type="file"
                                                            multiple
                                                            id="file-upload"
                                                            name="file-upload"
                                                            className="sr-only"
                                                            onClick={(e) => {
                                                                e.target.value = null;
                                                            }}
                                                            disabled={this.state.isImageUploaded}
                                                            onChange={this.handleFileUpload}
                                                            accept=".png,.jpeg,.jpg,.pdf"
                                                        />
                                                        <label
                                                            htmlFor="file-upload"
                                                            className="relative flex items-center justify-center p-8 rounded cursor-pointer"
                                                        >
                                                            <span className="text-white">
                                                                <div className="w-12 h-12 bg-[#543CC2] rounded-full flex items-center justify-center p-[14px] mx-auto">
                                                                    <svg
                                                                        width="20"
                                                                        height="20"
                                                                        viewBox="0 0 20 20"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M5 10H15"
                                                                            stroke="white"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M10 15V5"
                                                                            stroke="white"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>{' '}
                                                                </div>
                                                                <div className="flex mt-4 text-sm leading-6 text-muted">
                                                                    <p className="pl-1 text-sm font-normal text-[#B9B9B9]">
                                                                        {this.props.t(
                                                                            'uploadInstructions'
                                                                        )}
                                                                    </p>
                                                                </div>
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.uploadedImage &&
                                        this.state.uploadedImage.length ? (
                                            <div className="flex flex-row flex-wrap w-auto gap-3 mt-4 bg-transparent rounded-lg max-w-fit min-width-50">
                                                {this.state.uploadedImage.map((res, index) => {
                                                    return (
                                                        <div
                                                            className="relative upload"
                                                            key={index}
                                                        >
                                                            <span
                                                                className="cursor-pointer fas fa-times-circle text-red"
                                                                style={{
                                                                    position: 'absolute',
                                                                    right: '-5px',
                                                                    top: '-5px',
                                                                }}
                                                                onClick={() => {
                                                                    this.removeObject(
                                                                        index,
                                                                        'image'
                                                                    );
                                                                }}
                                                            ></span>
                                                            <div className="border border-[#34373E] rounded upload-img">
                                                                {res.includes(
                                                                    'data:application/pdf'
                                                                ) ? (
                                                                    <div>
                                                                        <i
                                                                            className="fa-solid fa-file-pdf"
                                                                            style={{
                                                                                color: '#c30909',
                                                                                width: '5rem',
                                                                                height: '5rem',
                                                                                borderRadius:
                                                                                    '0.5rem',
                                                                                fontSize: '50px',
                                                                                display: 'flex',
                                                                                justifyContent:
                                                                                    'center',
                                                                                alignItems:
                                                                                    'center',
                                                                            }}
                                                                        ></i>
                                                                    </div>
                                                                ) : (
                                                                    <img
                                                                        src={res}
                                                                        className="w-20 h-20 rounded"
                                                                        key={index}
                                                                        alt=""
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="flex items-end justify-end mt-6 sm:mt-auto">
                                    <button
                                        type="button"
                                        className="sm:w-1/6 w-full text-white font-semibold bg-black px-3 py-1.5 rounded-lg"
                                        onClick={() => {
                                            this.resetStateValue();
                                            this.props.history.push(
                                                `${PATH.IM_PATIENT.APPOINTMENT}/${this.props.match.params.userId}/`
                                            );
                                        }}
                                    >
                                        {this.props.t('cancel')}
                                    </button>
                                    {this.state.isOneToOne ? (
                                        <button
                                            onClick={() => this.handleSubmitOndemand()}
                                            disabled={this.state.isLoading}
                                            className="rounded-lg bg-UIprimary px-3 py-1.5 text-base font-semibold text-white sm:w-1/6 w-full ml-4"
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                {this.state.isLoading ? (
                                                    <Spinner color="#FFF" />
                                                ) : (
                                                    this.props.t('create')
                                                )}
                                            </div>
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => this.handleSubmitCreateAppointment()}
                                            disabled={this.state.isLoading}
                                            className="rounded-lg bg-UIprimary  px-3 py-1.5 text-base w-full font-semibold text-white sm:w-1/6 ml-4"
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                {this.state.isLoading ? (
                                                    <Spinner color="#FFF" />
                                                ) : (
                                                    this.props.t('create')
                                                )}
                                            </div>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <TimeSlots
                    openModal={this.state.openTimeShotModal}
                    closeModal={() => {
                        this.setState({ openTimeShotModal: false });
                    }}
                    timeSlots={this.state.timeSlots}
                    handleChangeTime={this.handleChangeTime}
                    timeApp={this.state.timeApp}
                    startDate={this.state.startDate}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        subjectList: state.patientAppointmentState.subjectList,
        subCategoryList: state.patientAppointmentState.subCategoryList,
        educatorList: state.patientAppointmentState.educatorList,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSubCategoryList: (subjectId, values, callBack) => {
            dispatch(getSubCategoryList(subjectId, values, callBack));
        },
        getEducatorList: (sessionType, values, callBack) => {
            dispatch(getEducatorList(sessionType, values, callBack));
        },
        getStudentEducatorSubject: (id, values, callback) => {
            dispatch(getStudentEducatorSubject(id, values, callback));
        },
        getEducatorAvailablityDays: (educatorId, callback) => {
            dispatch(getEducatorAvailablityDays(educatorId, callback));
        },
        getEducatorAvailability: (educator, date, callBack) => {
            dispatch(getEducatorAvailability(educator, date, callBack));
        },
        onDemandBook: (values, callBack) => {
            dispatch(postOndemandAppointment(values, callBack));
        },
        showNotification: (values, callback) => {
            dispatch(showNotification(values, callback));
        },
    };
};

const ConnectedCreateSession = withLanguage(
    connect(mapStateToProps, mapDispatchToProps)(CreateSession)
);

export default (props) => (
    <LanguageProvider>
        <ConnectedCreateSession {...props} />
    </LanguageProvider>
);
